import React, { useEffect, useState } from 'react';
// import getConfig from 'next/config';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ReCAPTCHA from 'react-google-recaptcha';
import styles from './styles';

// const { publicRuntimeConfig } = getConfig();
let savedPass = '';

const LoginFields403 = ({
  emailAddress,
  setemailAddress,
  userPassword,
  setUserPassword,
  // loginError,
  // isApiError,
  setDisablecta,
  onLoadingDisablecta,
  handleLoginButtonThroughPass,
  setLoginError,
  invalidText,
  handleOnChange,
  recaptchaRef,
}) => {
  const theme = useTheme();
  const [passwordVisibility, setPasswordVisibility] = useState(false);

  const [enableSubmit, setEnableSubmit] = useState(false);

  // eslint-disable-next-line
  const validEmailAddress = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
  const validPassword = /^.{6,}$/;
  // eslint-disable-next-line

  function validateEmail(email) {
    if (validEmailAddress.test(email)) {
      setEnableSubmit(true);
      return true;
    }
    setEnableSubmit(false);
    return false;
  }

  function handleEmailAddress(event) {
    const email = event.target.value;
    setemailAddress(email);
  }
  useEffect(() => {
    if (emailAddress.length !== 0 || userPassword.length !== 0) {
      if (validateEmail(emailAddress) && validPassword.test(userPassword)) {
        setDisablecta(false);
        const input = document.getElementById('input-text-id');
        if (input !== null && input !== undefined) {
          input.addEventListener('keyup', event => {
            if (event.key === 'Enter') {
              if (userPassword === savedPass) {
                handleLoginButtonThroughPass();
              }
            }
          });
        }
      } else {
        setDisablecta(true);
      }
    } else {
      setLoginError('');
      setDisablecta(true);
    }
  }, [emailAddress, userPassword]);

  const handlePasswordVisibility = () => {
    setPasswordVisibility(!passwordVisibility);
  };

  function handleUserPassword(event) {
    const password = event.target.value;
    savedPass = password;
    setUserPassword(password);
  }

  let emailTextFieldStyle = 'input-text';

  if (!emailAddress) {
    emailTextFieldStyle += ' text-empty';
  } else if (enableSubmit) {
    emailTextFieldStyle += onLoadingDisablecta ? ' text-empty' : ' text-entered';
  } else {
    emailTextFieldStyle += ' text-entered-invalid';
  }

  let passwordTextFieldStyle = 'input-text';

  if (!userPassword) {
    passwordTextFieldStyle += ' text-empty';
  } else if (userPassword) {
    passwordTextFieldStyle += onLoadingDisablecta ? ' text-empty' : ' text-entered';
  } else {
    passwordTextFieldStyle += ' text-entered-invalid';
  }

  return (
    <Box>
      <Box sx={styles(theme).bodyContainer}>
        <div className='text-field'>
          <input
            className={emailTextFieldStyle}
            type='email'
            id='email'
            autoComplete='On'
            placeholder='Enter username'
            value={emailAddress}
            onChange={handleEmailAddress}
            disabled={onLoadingDisablecta}
          />
          {!enableSubmit && emailAddress !== '' && (
            <div className='invalid-email-format'>Please enter a valid email ID</div>
          )}
          {/* {isApiError ? <div className='invalid-email-format'>{loginError}</div> : ' '} */}
        </div>
        <div className='text-field'>
          {passwordVisibility ? (
            <VisibilityOffIcon
              className={`${onLoadingDisablecta ? 'visibility-disable' : 'visibility-off'}`}
              onClick={handlePasswordVisibility}
              tabIndex={0}
            />
          ) : (
            <VisibilityIcon
              className={`${onLoadingDisablecta ? 'visibility-disable' : 'visibility-on'}`}
              onClick={handlePasswordVisibility}
              tabIndex={0}
            />
          )}
          <input
            className={passwordTextFieldStyle}
            id='input-text-id'
            type='password'
            placeholder='Enter password'
            autoComplete='On'
            value={userPassword}
            onChange={handleUserPassword}
            disabled={onLoadingDisablecta}
          />
        </div>
      </Box>
      <Box sx={styles(theme).mainContainer}>
        {/* Recaptcha v2 incase v3 failed */}
        {invalidText === 'Invalid reCAPTCHA!' && (
          <div className={styles(theme).reCaptchaError}>
            <div className={styles(theme).reCaptcha}>
              <ReCAPTCHA
                ref={recaptchaRef}
                className='reCaptchaRobot'
                sitekey='6LfZsRYTAAAAAJMBqawqK3sy7NmHDC8M9rKdkX36'
                render='explicit'
                onChange={handleOnChange}
              />
            </div>
          </div>
        )}
      </Box>
    </Box>
  );
};

export default LoginFields403;
